import * as tslib_1 from "tslib";
import { IgrDefinitionBase } from "./igr-definition-base";
import { ColumnResizingSeparator } from "./ColumnResizingSeparator";
var IgrColumnResizingSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrColumnResizingSeparator, _super);
    function IgrColumnResizingSeparator(props) {
        return _super.call(this, props) || this;
    }
    IgrColumnResizingSeparator.prototype.createImplementation = function () {
        return new ColumnResizingSeparator();
    };
    Object.defineProperty(IgrColumnResizingSeparator.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    return IgrColumnResizingSeparator;
}(IgrDefinitionBase));
export { IgrColumnResizingSeparator };
//# sourceMappingURL=igr-column-resizing-separator.js.map
